import * as React from 'react'
import {
  ContentUpload,
  IngestedFromRoute,
  IngestedItemFromRoute,
  PartnerContentUploadWrapper,
  PresentationsFixWrapper,
  VersionMappingParams,
} from './RouteWrappers'

import { AdminIntrospection } from 'components/AdminIntrospection'
import { CleanupTools } from 'components/resources/tool_components/CleanupTools'
import { CurriculaVersionUpdate } from 'components/tree/masters/updates/CurriculaVersionUpdate'
import { ExportStandardsContainer } from 'components/tree/ExportStandards'
import { HtmlContentUpdatesWrapper } from 'components/tree/htmlContentUpdates/HtmlContentUpdates'
import { IDVerificationWrapper } from 'components/tree/masters/IDVerification'
import { Index } from 'components/tree/Index'
import { IngestionIndex } from 'components/ingestion/IngestionIndex'
import { Test as IngestionTest } from 'ingestion/Test'
import { Masters } from 'components/Masters'
import { MastersImport } from 'components/masters_management/MastersImport'
import { Mathjax } from 'components/mathjax/Mathjax'
import { NewBundledCurricula } from 'components/NewBundledCurricula'
import { NodeUpdatesWrapper } from 'components/tree/nodeUpdates/NodeUpdates'
import { Partner } from 'components/ingestion/Partner'
import { ResourceIndexPage } from 'components/ResourceIndexPage'
import { Test as StandardsTest } from 'components/standards/StandardsTest'
import { TreeEditing } from 'components/tree_editing/TreeEditing'
import { IngestStandards } from 'components/IngestStandards'
import { TreeManagementWrapper } from 'components/tree/TreeManagement'
import { AddStandardsToCurricula } from 'components/tree/AddStandardsToCurricula/AddStandardsToCurricula'
import { ProductsVerification } from 'components/resources/products/ProductsVerification'
import { SectionOverviewsForVA } from 'components/tree/SectionOverviewsForVA/SectionOverviewsForVA'
import { CurriculaVersionMigrate } from 'components/tree/masters/migration/CurriculaVersionMigrate'
import { OneOffToolsWrapper } from 'components/tree/oneOffTreeTools/OneOffTools'
import { DeveloperSandbox } from 'components/DeveloperSandbox'
import { UpdateStandards } from 'components/standards/UpdateStandards'
import { SearchKiddomStandards } from 'components/standards/SearchKiddomStandards'
import { RouterMenu } from 'app/components/Dashboard'
import { LoginPage } from 'app/components/LoginPage'
import { resources } from 'app/resources'
import { withIdParam, WithResourceId } from 'app/components/WithIdParam'
import AppLayout from 'app/AppLayout'
// eslint-disable-next-line no-restricted-imports
import { RouteObject } from 'react-router'
import {
  FlowIdInputRoute,
  FlowResultRoute,
} from 'components/contentService/JobView'
import { FlowStartandMonitorExample } from 'components/contentService/FlowStartandMonitorExample'
import { Playground } from 'components/contentService/Playground'
import { AiTreeToolBatch } from 'components/ai-tree-tool-batch'
import { PromptRunner } from 'components/tree/AITreeTool/PromptRunner'
import { PdfTranslate } from 'components/contentService/PdfTranslate'
import { PresentationFilesIndex } from 'components/presentation_files/PresentationFilesIndex'
import { Crosswalks } from 'domains/scope-and-sequence/features/crosswalk/Crosswalks'
import { Frameworks } from 'domains/scope-and-sequence/features/frameworks/Frameworks'
import { ScopeAndSequence } from 'domains/scope-and-sequence/features/tree-creation/ScopeAndSequence'
import { LessonMappings } from 'domains/scope-and-sequence/features/lesson-mappings/LessonMappings'
import { Landing as ScopeAndSequenceLanding } from 'domains/scope-and-sequence/features/landing/Landing'
import { RouteErrorFallback } from 'shared/ui/ErrorFallback'

const devTools = [
  {
    key: 'updateStandards',
    path: '/standards_tools/update_standards',
    element: <UpdateStandards />,
    title: 'Update Standards',
    description: 'Update Kiddom standards from EdGate',
  },
  {
    key: 'contentServicePlayground',
    path: '/content_service/playground',
    element: <Playground />,
    title: 'Content Service Playground',
    description: 'Test the content service',
  },
  {
    key: 'flowStartAndMonitorExample',
    path: '/content_service/flow_example',
    element: <FlowStartandMonitorExample />,
    title: 'Job Flow Example',
    description: 'Test the content service job flow component',
  },
  {
    key: 'promptRunner',
    path: '/ai_tree_tool/prompt_runner',
    element: <PromptRunner />,
    title: 'Prompt Runner',
    description: 'Run AI prompts with user messages',
  },
  {
    key: 'aiTreeToolBatch',
    path: '/ai_tree_tool/batch',
    element: <AiTreeToolBatch />,
    title: 'AI Tree Tool Batch Processing',
    description: 'Batch AI tree tool operations',
  },
  {
    key: 'pdfTranslate',
    path: '/content_service/pdf_translate',
    element: <PdfTranslate />,
    title: 'PDF Tools',
    description: 'Translate PDFs and run tree-level PDF discovery',
  },
]

const scopeAndSequenceRoutes = [
  {
    key: 'scopeAndSequence',
    path: '/scope_and_sequence/parse',
    element: <ScopeAndSequence />,
    title: 'Scope and Sequence',
    description: 'Parse Scope & Sequence',
  },
  {
    key: 'crosswalks',
    path: '/scope_and_sequence/crosswalks',
    element: <Crosswalks />,
    title: 'Crosswalks',
    description: 'Crosswalks for scope and sequence',
  },
  {
    key: 'frameworks',
    path: '/scope_and_sequence/frameworks',
    element: <Frameworks />,
    title: 'Frameworks',
    description: 'Frameworks for scope and sequence',
  },
  {
    key: 'lessonMappings',
    path: '/scope_and_sequence/lesson_mappings',
    element: <LessonMappings />,
    title: 'Lesson Mappings',
    description: 'Lesson Mappings for scope and sequence',
  },
]

// These show up as links on the main dashboard
export const dashboardLinks = [
  {
    key: 'tree_index',
    path: '/tree',
    element: <Index />,
    title: 'Tree Operations',
    description: 'Index for all things tree',
  },
  {
    key: 'masters',
    path: '/masters',
    element: <Masters />,
    title: 'Masters',
    description: 'Index of all current bundled curricula',
  },
  {
    key: 'curriculaVersionUpdate',
    path: '/curricula_version_update',
    element: <CurriculaVersionUpdate />,
    title: 'Curricula Version Update',
    description: 'Update existing bundled curricula',
  },
  {
    key: 'newBundledCurricula',
    path: '/new_bundled_curricula',
    element: <NewBundledCurricula />,
    title: 'New Bundled Curricula',
    description:
      'Create new bundled curricula, you probably do not want to use this in the production environment',
  },
  {
    key: 'mastersImport',
    path: '/masters_import',
    element: <MastersImport />,
    title: 'Production Masters Import',
    description: 'Pull production masters into local environment',
  },
  {
    key: 'introspection',
    path: '/admin/introspection',
    element: <AdminIntrospection />,
    title: 'Admin Introspection',
    description: 'See what admin queries/mutations are available',
  },
  {
    key: 'resource_index_page',
    path: '/resource_index',
    element: <ResourceIndexPage />,
    title: 'Resources Index',
    description: 'See what tools and resources are available',
  },
  {
    key: 'cleanup_tools',
    path: '/cleanup_tools',
    element: <CleanupTools />,
    title: 'Database Clean-up',
    description: 'Collection of operations that can be run against database',
  },
  {
    key: 'presentation_files',
    title: 'Presentation Files',
    element: <PresentationFilesIndex />,
    path: '/presentation_files',
    description: 'Presentation files maintenance',
  },
  {
    key: 'scope_and_sequence',
    path: '/scope_and_sequence',
    element: <ScopeAndSequenceLanding />,
    title: 'State Adoption Course Builder',
    description: 'State Adoption Course Builder',
  },
  {
    key: 'dev_tools',
    path: '/dev_tools',
    element: <RouterMenu menuTitle={'Dev Tools'} routes={devTools} />,
    title: 'Dev Tools',
    description: 'Collection of tools and resources to assist in development',
  },
  {
    key: 'searchKiddomStandards',
    path: '/standards_tools/search_kiddom_standards',
    element: <SearchKiddomStandards />,
    title: 'Search Kiddom Standards',
    description:
      'Search, view and export Kiddom standards by state and subject',
  },
]

// These show up as links on the Tree page
export const treeRoutes = [
  {
    key: 'treeManagement',
    path: '/tree_management/:treeVersionNodeId?',
    element: <TreeManagementWrapper />,
    title: 'Tree Management',
    description:
      'Tools to operate on a tree as copy, alt text, image verification, etc',
  },
  {
    key: 'idVerification',
    path: '/id_verification/:productId',
    element: <IDVerificationWrapper />,
    title: 'ID Editable Copy Verification',
    description: 'Verify master editable copies are in a good state',
  },
  {
    key: 'exportStandards',
    path: '/export-standards/:treeVersionNodeId?',
    element: <ExportStandardsContainer />,
    title: 'Export Standards from Curricula',
    description:
      'Export a list of unique standards present in the curricula as a csv',
  },
  {
    key: 'addStandardsToCurricula',
    path: '/add-standards-to-curricula',
    element: <AddStandardsToCurricula />,
    title: 'Add Standards to Curricula',
    description: 'Bulk add standards to curricula from a google sheet',
  },
  {
    key: 'treeEditing',
    path: '/tree_edit',
    element: <TreeEditing />,
    title: 'Tree Edit',
    description:
      'Drag-and-drop tree editing interface for copying, reordering, and managing curriculum tree nodes',
  },
]

const resourceRoutes = resources.reduce<RouteObject[]>((acc, resource) => {
  const { key, List, Single, Edit, Create } = resource
  if (List) {
    acc.push({
      path: `/${key}`,
      element: <WithResourceId resourceKey={key} component={List} />,
    })
  }
  if (Single) {
    acc.push({
      path: `/${key}/:id/show`,
      element: withIdParam(key, Single),
    })
  }
  if (Edit) {
    acc.push({
      path: `/${key}/:id/edit`,
      element: withIdParam(key, Edit),
    })
  }
  if (Create) {
    acc.push({
      path: `/${key}/create`,
      element: <Create />,
    })
  }
  return acc
}, [])

export const routerRoutes = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        // Pathless wrapper route: catches all child route errors while
        // keeping AppLayout (nav, drawer) visible.
        errorElement: <RouteErrorFallback />,
        children: [
          {
            path: '/',
            element: (
              <RouterMenu
                menuTitle={'Welcome to the administration'}
                routes={dashboardLinks}
              />
            ),
          },
          { path: '/login', element: <LoginPage /> },
          ...resourceRoutes,
          ...treeRoutes.map(({ path, element }) => ({ path, element })),
          ...dashboardLinks.map(({ path, element }) => ({ path, element })),
          ...devTools.map(({ path, element }) => ({ path, element })),
          ...scopeAndSequenceRoutes.map(({ path, element }) => ({
            path,
            element,
          })),
          { path: '/masters/:treeId', element: <Masters /> },
          { path: '/content_upload', element: <ContentUpload /> },
          {
            path: '/content_upload/:partnerId/:currId/:gradeCode',
            element: <PartnerContentUploadWrapper />,
          },
          {
            path: '/version_mapping/from/:fromTreeId/to/:toTreeId',
            element: <VersionMappingParams />,
          },
          {
            path: '/curricula_version_migrate',
            element: <CurriculaVersionMigrate />,
          },
          {
            path: '/presentations_fix/:treeVersionNodeId',
            element: <PresentationsFixWrapper />,
          },
          { path: '/html_updates', element: <HtmlContentUpdatesWrapper /> },
          {
            path: '/html_updates/:treeVersionNodeId',
            element: <HtmlContentUpdatesWrapper />,
          },
          { path: '/node_updates', element: <NodeUpdatesWrapper /> },
          {
            path: '/node_updates/:treeVersionNodeId',
            element: <NodeUpdatesWrapper />,
          },
          { path: '/test/standards_v2', element: <StandardsTest /> },
          { path: '/tree_edit', element: <TreeEditing /> },
          { path: '/one_off_tree_tools', element: <OneOffToolsWrapper /> },
          {
            path: '/one_off_tree_tools/:treeVersionNodeId',
            element: <OneOffToolsWrapper />,
          },
          {
            path: '/section_overviews_for_va',
            element: <SectionOverviewsForVA />,
          },
          {
            path: '/tree_management/:treeVersionNodeId/node/:NodeId',
            element: <TreeManagementWrapper />,
          },
          { path: '/tree/:treeVersionNodeId', element: <Index /> },
          { path: '/mathjax', element: <Mathjax /> },
          { path: '/developer_sandbox', element: <DeveloperSandbox /> },
          { path: '/ingestion', element: <IngestionIndex /> },
          { path: 'ingestion/standards', element: <IngestStandards /> },
          { path: '/ingestion/partner/:partnerKey', element: <Partner /> },
          {
            path: '/ingestion/partner/:partnerKey/ingested',
            element: <IngestedFromRoute />,
          },
          {
            path: '/ingestion/partner/:partnerKey/ingested/:ingestionId',
            element: <IngestedItemFromRoute />,
          },
          {
            path: '/ingestion-engine/:partnerId',
            element: <IngestionTest />,
          },
          {
            path: '/products/verification',
            element: <ProductsVerification />,
          },
          {
            path: '/content_service/flow/:flowId',
            element: <FlowResultRoute />,
          },
          {
            path: '/content_service/flow',
            element: <FlowIdInputRoute />,
          },
        ],
      },
    ],
  },
]
